<template>
  <div class="photo-gallery-page" v-if="photoGalleryShow" @touchmove.prevent @touchstart.prevent>
    <div class="page-indicator-panel" v-html="(curIndex+1)+'<span style=font-weight:200>/</span>'+imgList.length"
         v-if="imgList.length>0"></div>
    <slider :options="slideInit" ref="slider" @slide="onSlide" class="slider">
      <slideritem v-for="(item,index) in slidePages" :key="index" @tap="hideGallery" :style="item.style"
                  v-html="item.html"
                  @click="hideGallery"></slideritem>
    </slider>

  </div>

</template>

<script>
  import slider from 'vue-concise-slider/src/components/slider'
  import slideritem from 'vue-concise-slider/src/components/slider_item'
  import defaultCover from '../../assets/imgs/icon_default_img.png'
  import {isnull} from "../../utils/tools";

  export default {
    name: "PhotoGallery",
    props: {
      photoGalleryShow: {
        type: Boolean,
        default: false
      },
      imgList: [],
      startIndex: 0,
      from: ''
    },
    methods: {
      hideGallery() {
        this.$emit('hidePhotoGallery')
      },
      onSlide(data) {
        this.curIndex = data.currentPage
      },
    },
    components: {
      slider,
      slideritem,

    },
    watch: {
      photoGalleryShow(n, o) {
        if (n) {
          this.curIndex=this.startIndex
          this.slidePages = []
          for (let i = 0; i < this.imgList.length; i++) {
            this.slidePages.push({
              title: '',
              html: '<img src="' + this.imgList[i] + '" alt=""  onerror="' + this.errorCover + '" class="vp-album" style="width: 100%;height: 100%; object-fit: contain">',
            })
          }
          this.slideInit.currentPage = this.curIndex
        }
      }
    },
    data() {
      return {
        slidePages: [],
        curIndex: 0,
        errorCover: 'this.src="' + defaultCover + '"',
        slideInit: {
          currentPage: 0,//当前页码
          thresholdDistance: 80, // 滑动距离阈值判定
          thresholdTime: 600, // 滑动时间阈值判定
          grabCursor: true, // 抓标样式
          speed: 300, // 滑动速度
          // autoplay:1000,//自动滚动[ms]
          // loop:true,//循环滚动
          direction: 'horizontal',//方向设置，垂直滚动
          pagination: false,
        },
      }
    }
  }
</script>

<style scoped lang="less">
  @import "~styles/index.less";
  @import "~styles/variable.less";

  .photo-gallery-page {
    position: fixed;
    z-index: 500;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .8);

    .slider {
      height: 100% !important;
      position: absolute !important;
      z-index: 0 !important;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

    }

    .page-indicator-panel {
      width: 100%;
      text-align: center;
      position: absolute;
      .mt(31);
      .fs(40);
      font-family: Gilroy-Medium;
      font-weight: bold;
      color: #FFFFFF;
      .lh(52);
      .h(52);
      z-index: 3;
    }


  }

</style>



// WEBPACK FOOTER //
// src/components/widget/PhotoGallery.vue